/**
 * @file automatically generated from MApp.Endpoints.WorkflowContentController
 */

import { MetadataClient } from '../metadata-client';
import { ISaveWorkflow, IWorkflow, IWorkflowListItem, IValidationResult, IWorkflowNodeListItem } from '../models';

export class WorkflowContentClient extends MetadataClient {

	public static saveWorkflow(workflow: ISaveWorkflow, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(workflow),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateWorkflow(id: string, workflow: ISaveWorkflow, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(workflow),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getWorkflow(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IWorkflow>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getWorkflows(requestInit?: RequestInit) {
		return MetadataClient.ajax<IWorkflowListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static deleteWorkflow(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static isValidWorkflow(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IValidationResult>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/isvalid?name=${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getWorkflowNodes(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IWorkflowNodeListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}/nodes`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}
}
